import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { Fade, Collapse, Paper, Grid, Typography, Button } from '@mui/material';
import toast from 'react-hot-toast';
import Modal from '@mui/material/Modal';
import Backdrop from '@mui/material/Backdrop';

import {
  updateUserRegistrationChoices,
  userOccupation,
} from '../../store/actions/register';
import { fetchUserDetails } from '../../store/actions/user';
import { fetchSports } from '../../store/actions/common';
import { gtPostActivity } from '../../store/actions/feed';
import * as ROUTES from '../../constants/routes';
import { _lt } from '../../localization/locale';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const BranchingAdd = (props) => {
  const theme = useTheme();
  const [secondOptions, setSecondOptions] = useState(null);
  const [secondOption, setSecondOption] = useState(null);
  const [thirdOptions, setThirdOptions] = useState(null);
  const [firstOption, setFirstOption] = useState(null);
  const [collapseOne, setCollapseOne] = useState(false);
  const [collapseTwo, setCollapseTwo] = useState(false);
  const [modalValue, setModalValue] = useState('');
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: '#ffffff',
    boxShadow: 24,
    p: 4,
  };

  const userRoles = [
    'Athlete',
    'Guardian',
    'Coach',
    'Owner/Admin',
    'Scout',
    'Agent',
  ];

  const classes = {
    root: {
      background:
        'linear-gradient(#d3cff620,#ffffff,#ffffff,#d3cff610,#d3cff620)',
      backgroundSize: 'cover',
      height: '100vh',
      overflow: 'scroll',
    },
    formWrapper: {
      width: '100%',
      //maxWidth: '1200px',
      height: 'max-content',
    },
    formContentWrapper: {
      width: '100%',
    },

    gridItemWrapper: {
      display: 'flex',
      justifyContent: 'center',
    },
    gridItems: {
      width: '150px',
      height: '100px',
      backgroundColor: '#fafafa',
      //border: '0.25px solid #eee',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:hover': {
        boxShadow: '0 4px 8px #e8e8e8',
      },
    },
    itemTwo: {
      width: '150px',
      height: 'max-content',
      padding: '16px',
      cursor: 'pointer',
      backgroundColor: '#fafafa',
    },
  };

  const firstOptionHandler = (event) => {
    console.log(event.target.textContent);
    if (event.target.textContent !== firstOption) {
      setCollapseOne(false);
    }
    setTimeout(() => {
      setFirstOption(event.target.textContent);
      if (event.target.textContent === 'Athlete') {
        setSecondOptions([
          { code: 11, value: _lt('An athlete below 15 years') },
          { code: 12, value: _lt('An athlete above 15 years') },
        ]);
        setCollapseOne(true);
      } else if (event.target.textContent === 'Guardian') {
        setSecondOptions([
          { code: 31, value: _lt('Have registered with my personal email') },
          { code: 32, value: _lt("Have registered with the minor's email") },
        ]);
        setCollapseOne(true);
      } else if (
        event.target.textContent === 'Coach' ||
        event.target.textContent === 'Scout' ||
        event.target.textContent === 'Agent'
      ) {
        setSecondOptions(null);
        handleOpen();
      } else if (event.target.textContent === 'Owner/Admin') {
        setSecondOptions([
          { code: 31, value: _lt('An owner or admin or manager of a team') },
          {
            code: 32,
            value: _lt(
              'An owner/admin of a club, academy or educational institute',
            ),
          },
        ]);
        setCollapseOne(true);
      }
      setThirdOptions(null);
    }, 100);
  };

  const secondOptionHandler = (event) => {
    if (event.target.textContent !== secondOption) {
      setCollapseTwo(false);
    }
    setTimeout(() => {
      setSecondOption(event.target.textContent);
      if (event.target.textContent === 'An athlete below 15 years') {
        setThirdOptions([
          {
            code: 11,
            value: _lt("Have my guardian's contact info to proceed"),
          },
          {
            code: 12,
            value: _lt("Don't have my guardian's contact info right now"),
          },
        ]);
        setCollapseTwo(true);
      } else if (event.target.textContent === 'An athlete above 15 years') {
        handleOpen();
        console.log(event.target.textContent);
        setModalValue('An athlete above 15 years');
      } else if (
        event.target.textContent === 'Have registered with my personal email'
      ) {
        setThirdOptions([
          {
            code: 11,
            value: _lt(
              "Want to create the ward's account too, so handing over is easier when they grow up",
            ),
          },
          {
            code: 12,
            value: _lt(
              "No, don't want to create a personal account for the minor",
            ),
          },
        ]);
        setCollapseTwo(true);
      } else if (
        event.target.textContent === "Have registered with the minor's email"
      ) {
        setThirdOptions([
          {
            code: 11,
            value: _lt(
              'Want to create my personal account too, so handing over is easier when they grow up',
            ),
          },
          {
            code: 12,
            value: _lt("No, don't want to create my personal account"),
          },
        ]);
        setCollapseTwo(true);
      } else if (
        event.target.textContent === 'An owner or admin or manager of a team'
      ) {
        handleOpen();
      } else if (
        event.target.textContent ===
        'An owner/admin of a club, academy or educational institute'
      ) {
        handleOpen();
      }
    }, 100);
  };

  const thirdOptionHandler = (event) => {
    if (
      event.target.textContent ===
      "Don't have my guardian's contact info right now"
    ) {
      toast.error(
        _lt(
          'Sorry, you cannot proceed. Please ask your parent/guardian to register.',
        ),
      );
    } else if (
      event.target.textContent === "Have my guardian's contact info to proceed"
    ) {
      handleOpen();
      setModalValue(event.target.textContent);
    } else if (
      event.target.textContent ===
      "Want to create the ward's account too, so handing over is easier when they grow up"
    ) {
      handleOpen();
      setModalValue(event.target.textContent);
    } else if (
      event.target.textContent ===
      'Want to create my personal account too, so handing over is easier when they grow up'
    ) {
      handleOpen();
      setModalValue(event.target.textContent);
    } else if (
      event.target.textContent ===
      "No, don't want to create my personal account"
    ) {
      handleOpen();
      setModalValue(event.target.textContent);
    }
  };

  const submitHandler = (event) => {
    event.preventDefault();
    console.log('props.info', props.info);
    props.updateUserRegistrationChoices(
      `${firstOption}-${secondOption}-${modalValue}`,
    );
    props.userOccupation(firstOption).then(async () => {
      console.log('props.info post occupation', props.info);
      if (
        modalValue === 'An athlete above 15 years' ||
        modalValue === "No, don't want to create my personal account"
      ) {
        if (props.info.version === 1) {
          await gtPostActivity('newuser');
        }
        props.history.push(ROUTES.ATHLETE_SPORT_ADD);
      } else if (
        modalValue === "Have my guardian's contact info to proceed" ||
        modalValue ===
          "Want to create the ward's account too, so handing over is easier when they grow up" ||
        modalValue ===
          'Want to create my personal account too, so handing over is easier when they grow up'
      ) {
        if (props.info.version === 1) {
          await gtPostActivity('newuser');
        }
        props.history.push(ROUTES.SIGN_UP_GUARDIAN);
      } else {
        if (props.info.version === 1) {
          await gtPostActivity('newuser');
        }
      }
    });
  };

  return (
    <Box sx={classes.root}>
      <Box sx={classes.formWrapper}>
        <Box
          sx={{
            height: '100px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mt: 6,
          }}
        >
          <Typography sx={{ fontSize: '36px', fontWeight: '600' }}>
            What in the following describes you best?
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2,
          }}
        >
          <Typography variant="p">
            This information will help us set your account up better
          </Typography>
        </Box>
        <Fade in={true} timeout={500}>
          <Box sx={classes.formContentWrapper}>
            <Grid container display="flex" justifyContent="center">
              {userRoles.map((selection) => (
                <Box sx={{ m: 1 }}>
                  <Grid item sx={classes.gridItemWrapper}>
                    <Paper
                      onClick={firstOptionHandler}
                      sx={
                        selection === firstOption
                          ? {
                              ...classes.gridItems,
                              backgroundColor: '#888',
                              width: '150px',
                              height: '100px',
                              color: '#fff',
                            }
                          : classes.gridItems
                      }
                    >
                      <Typography>{selection}</Typography>
                    </Paper>
                  </Grid>
                </Box>
              ))}
            </Grid>
            {secondOptions && (
              <Collapse in={collapseOne} timeout={300}>
                <Grid item sx={classes.gridItemWrapper}>
                  {secondOptions.map((x, i) => (
                    <Box sx={{ m: 1 }}>
                      <Paper
                        onClick={secondOptionHandler}
                        key={`s_${i}`}
                        value={x.code}
                        sx={
                          x.value === secondOption
                            ? {
                                ...classes.itemTwo,
                                backgroundColor: '#ff0000',
                                color: '#ffffff',
                              }
                            : classes.itemTwo
                        }
                      >
                        {x.value}
                      </Paper>
                    </Box>
                  ))}
                </Grid>
              </Collapse>
            )}
            {thirdOptions && (
              <Collapse in={collapseTwo}>
                <Grid item sx={classes.gridItemWrapper}>
                  {thirdOptions.map((x, i) => (
                    <Box sx={{ m: 1 }}>
                      <Paper
                        onClick={thirdOptionHandler}
                        key={`s_${i}`}
                        value={x.code}
                        sx={classes.itemTwo}
                      >
                        {x.value}
                      </Paper>
                    </Box>
                  ))}
                </Grid>
              </Collapse>
            )}
          </Box>
        </Fade>
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 100,
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Typography
              variant="h4"
              component="h2"
              sx={{ marginBottom: '24px' }}
            >
              Proceed as {firstOption}
            </Typography>
            <Button variant="contained" onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="contained" onClick={submitHandler} sx={{ mx: 1 }}>
              Proceed
            </Button>
          </Box>
        </Fade>
      </Modal>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  info: state.user.info,
});

const mapDispatchToProps = {
  fetchUserDetails,
  fetchSports,
  updateUserRegistrationChoices,
  userOccupation,
};

const BranchingFormAdd = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BranchingAdd),
);

export default BranchingFormAdd;
